// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

// const ROOTS = "";
const ROOTS_AUTH = "/auth";
export const ETF_ROOT = "/etf";
const FUND_ROOT = "/fund";
const ROOTS_ASSET = "/asset";
const REALIY_ROOT = "/realty";
export const STOCK_ROOT = '/stock';
const BACKTEST_ROOT = "/backtest";
const ADMIN_ROOT = "/admin";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  //: 로그인 링크 메일의 버튼이 여기로 온다. 서버(`US_API_WEB_BASE_URL`)가 이
  //: 경로를 그대로 붙이므로 **바꾸면 메일 링크가 깨진다.**
  magic: path(ROOTS_AUTH, "/magic"),
};

export const PATH_ETF = {
  root: ETF_ROOT,
  // kr: path(ETF_ROOT, "/kr"),
  // us: path(ETF_ROOT, "/us"),
};

export const PATH_FUND = {
  root: FUND_ROOT,
  kr: path(FUND_ROOT, "/kr"),
};

export const PATH_ASSET = {
  root: ROOTS_ASSET,
  index_asset: path(ROOTS_ASSET, "/index"),
};

// develop 에서도 macro / msci / msciBand 는 주석 상태다. Global 만 옮긴다.
export const PATH_ASSET_INDEX = {
  root: PATH_ASSET,
  global: path(PATH_ASSET.index_asset, "/global"),
};

export const PATH_REALTY = {
  root: REALIY_ROOT,
  index: path(REALIY_ROOT, "/realty_indexes"),
};

export const PATH_STOCK = {
  root: STOCK_ROOT,
  // kr: path(STOCK_ROOT, "/kr"),
  // us: path(STOCK_ROOT, "/us"),
}

export const PATH_BACKTEST = {
  root: BACKTEST_ROOT,
  staticBacktest: path(BACKTEST_ROOT, "/static"),
};

// 가입 신청 알림 메일이 `/admin/users?request=<신청ID>` 로 링크한다.
// 주소가 탭을 정하므로 탭마다 경로가 하나씩 있어야 한다.
export const PATH_ADMIN = {
  root: ADMIN_ROOT,
  users: path(ADMIN_ROOT, "/users"),
  memberships: path(ADMIN_ROOT, "/memberships"),
  identity: path(ADMIN_ROOT, "/identity"),
};
